module.exports = __webpack_public_path__ + "static/banner-2b811fe527f217bccea91ea85f77a422.png";